import { useState } from "react";
// import axios from "axios";
import { Input, Button, Row, Col } from "antd";
import {
  SendOutlined,
  // PaperClipOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import EmojiPicker from "emoji-picker-react";
import { getMurphyPanelAsistente } from "../globals";
import { API_URL } from "../config";
import axios from "axios";

const MessageInput = ({
  onSendMessage,
  onReceiveMessage,
  onSendFile,
  onSessionExpired,
  setIsLoading,
}) => {
  const [message, setMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [file, setFile] = useState(null);
  const [getResponse, setGetResponse] = useState("");

  const generateTimestamp = () => new Date().toISOString();

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSend = () => {
    if (message !== "") {
      const timestamp = generateTimestamp();
      onSendMessage({ message, timestamp });
      setMessage("");
      setShowEmoji(false);
      handleResponse(message);
    } else if (file) {
      const timestamp = generateTimestamp();
      onSendFile({ file, timestamp });
      setFile(null);
      handleResponse(file);
    }
  };

  // const conversationId = localStorage.getItem("conversationId");

  //Manejo de respuesta del servidor
  // MessageInput.jsx
const handleResponse = async (message) => {
  try {
    setIsLoading(true);

    const response = await fetch(`${API_URL}/broker/ai`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        onSessionExpired();
        return;
      }
      throw new Error("Backend error");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let finalText = "";
    let buffer = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      // dividir por lineas (data: xxx)
      const lines = buffer.split(/\r?\n/);

      // ultima linea puede quedar incompleta
      buffer = lines.pop();

      for (const line of lines) {
        if (!line.startsWith("data:")) continue;

        const data = line.slice(5); // NO trim

        if (data === "[DONE]") {
          const timestamp = new Date().toISOString();
          onReceiveMessage({ message: finalText, timestamp });
          setIsLoading(false);
          return;
        }

        // Procesar el fragmento como JSON
        let parsed;
        try {
          parsed = JSON.parse(data);
        } catch (e) {
          // Si no es JSON válido, lo agregamos como texto plano
          finalText += data;
          onReceiveMessage({
            message: finalText,
            timestamp: new Date().toISOString(),
            streaming: true,
          });
          continue;
        }

        if (parsed && typeof parsed.content === "string") {
          finalText += parsed.content;
          if (parsed.isNewline) {
            finalText += "\n";
          }
        }

        // 🔥 MANDA AL FRONT EN TIEMPO REAL
        onReceiveMessage({
          message: finalText,
          timestamp: new Date().toISOString(),
          streaming: true,
        });
      }
    }
  } catch (err) {
    console.error("Error:", err);
  } finally {
    setIsLoading(false);
  }
};


  const onEmojiClick = (event) => {
    setMessage((prevInput) => prevInput + event.emoji);
  };

  const handleEmojiPicker = () => {
    setShowEmoji(!showEmoji);
  };

  // const handleFileUpload = () => {
  //   const input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = ".txt, image/jpeg, image/png, image/jpg";
  //   input.onchange = (e) => {
  //     const file = e.target.files[0];
  //     setFile(file);
  //   };
  //   input.click();
  // };

  return (
    <Row gutter={[0, 24]} align={"bottom"}>
      <Col span={22} style={{ marginRight: 10 }}>
        {file && (
          <>
            <a href={URL.createObjectURL(file)} style={{ color: "blue" }}>
              {file.name}
            </a>
            <button
              style={{
                marginLeft: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "blue",
                marginBottom: "10px",
              }}
              onClick={() => setFile(null)}
            >
              <DeleteOutlined />
            </button>
          </>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Input.TextArea
            value={message}
            onChange={handleInputChange}
            disabled={!!file}
            style={{
              border: getMurphyPanelAsistente("logoColorBorder"),
              resize: "none",
              minHeight: "36px",
              maxHeight: "120px",
              paddingRight: "36px",
            }}
            placeholder={"Message to " + getMurphyPanelAsistente("title")}
            autoSize={{ minRows: 1, maxRows: 5 }}
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault();
                handleSend();
              }
            }}
          />
          <Button
            type="text"
            disabled={!!file}
            onClick={handleEmojiPicker}
            style={{
              fontSize: "18px",
              padding: 0,
              lineHeight: 1,
              position: "absolute",
              top: "50%",
              right: "8px",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "none",
              border: "none",
            }}
          >
            🙂
          </Button>
        </div>

        {showEmoji && (
          <EmojiPicker
            searchDisabled="true"
            height={300}
            width={300}
            onEmojiClick={onEmojiClick}
            previewConfig={{ showPreview: false, showRecents: false }}
          />
        )}
      </Col>
      <Col span={1} style={{ textAlign: "right" }}>
        <Button
          disabled={!file && !message && !getResponse}
          onClick={handleSend}
          style={{
            backgroundColor: "#fff",
            border: getMurphyPanelAsistente("logoColorBorder"),
          }}
          shape="circle"
          icon={<SendOutlined />}
        />
      </Col>
    </Row>
  );
};

export default MessageInput;
